import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getBotMessages = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessages', METHOD_TYPES.GET, data, callback);
};

export const deleteBotMessage = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessage', METHOD_TYPES.DELETE, data, callback);
};

export const getBotMessagesSchema = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessagesSchema', METHOD_TYPES.GET, data, callback);
};

export const getBotMessageDetails = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessageDetails', METHOD_TYPES.GET, data, callback);
};

export const updateBotMessage = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessageDetails', METHOD_TYPES.PUT, data, callback);
};

export const createBotMessage = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/botMessageDetails', METHOD_TYPES.POST, data, callback);
};



// WEBPACK FOOTER //
// ./src/data/redux/botmessage_details/api.js